<template>
    <div :class="['custom-control custom-checkbox ' + customClass, checked ? 'checked' : '', disabled ? 'disabled' : '']">
        <input type="checkbox" class="custom-control-input" :id="customId" @change.prevent="handleClick" v-model="checked" :disabled="disabled">
        <label class="custom-control-label" :for="customId">{{customLabel}}</label>
    </div>
</template>

<script>
import bus from '@/js/event-bus.js';
    export default {
        name: 'v-checkbox',
        props: {
            customId: {
                type: String,
                default: '',
                required: true
            },
            customClass: {
                type: String,
                default: ''
            },
            customLabel: {
                type: String,
                default: 'Checkbox',
                required: true
            },
            selectedValueField: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean
            },
            selectedValue: {
                type: String
            },
            trueValue: {
                type: String,
                require: true
            },
            falseValue: {
                type: String,
                require: true
            }
        },
        data: function () {
            return {
                checked: false
            };
        },
        watch: {
            selectedValue: function () {
                this.checked = this.selectedValue === this.trueValue;
            }
        },
        mounted () {
            this.checked = this.selectedValue === this.trueValue;
        },
        methods: {
            handleClick () {
                bus.$emit('filter:click', {
                    'selectedValueField': this.selectedValueField,
                    'value': this.checked ? this.trueValue : this.falseValue
                });
            }
        }
    };
</script>

<style lang="scss">
.custom-checkbox {
    display: inline-block;
    // padding-left: 10px;
    // top: 2px;
    background: #fff;
    padding: 2px 10px;
    border-radius: 3px;
    font-family: $title-font-family;
    font-size: 14px;
    color: $grey;
    font-weight: 500;
    text-transform: capitalize;
    transition: 0.3s;

    .custom-control-label {
        padding: 2px 5px 0 25px;
        cursor: pointer;

        &:before {
            left: 0;
            top: 3px;
            box-shadow: none;
            // background-color: #ececec;
            // box-shadow: 0 1px 6px rgba(0,0,0,.2);
            color: #fff;
            // background-color: #fff;
            background-color: #aebdd7;
            border-radius: .25rem;
            width: 18px;
            height: 18px;
            border-radius: 2px;
        }

        &:after {
            left: -1px;
            top: 2px;
            width: 1.5rem;
            height: 1.5rem;
        }
    }

    &:hover:not(.disabled) {
        background-color: $primary;
        color: $white;
        text-decoration: none;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        outline: none;

        .custom-control-label {
            &:before {
                background-color: #fff;
            }
        }

        &.checked {
            // background: #fff;
            // color: $grey;
            // box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
            .custom-control-label {
                &:before {
                    background-color: #fff;
                }
            }

            .custom-control-label {
                &:after {
                    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23015496' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E")
                }
            }
        }
    }
}
</style>
